export { default } from './WarningSign';